module.exports = {
    items: {
        INTEGER: {
            id: 1,
        },
        DECIMAL: {
            id: 2,
        },
        BOOLEAN: {
            id: 3,
        },
        DATE_ISO8601: {
            id: 4,
        },
        DATE_MM_DD_YYYY: {
            id: 5,
        },
        DATE_DD_MM_YYYY: {
            id: 6,
        },
        DATE_ISO8601_TIME: {
            id: 7,
        },
        DATE_MM_DD_YYYY_TIME: {
            id: 8,
        },
        DATE_DD_MM_YYYY_TIME: {
            id: 9,
        },
        UNIX_SECONDS: {
            id: 10,
        },
        UNIX_MILLISECONDS: {
            id: 11,
        },
        CURRENCY: {
            id: 12,
        },
        PERCENTAGE: {
            id: 13,
        },
        INTERACTION: {
            id: 14,
        },
        CSM_SCORE_AGGREGATE: {
            id: 15,
        },
        NPS: {
            id: 16,
        },
        NPS_AGGREGATE: {
            id: 17,
        },
    },
};
